import { payoutStatus, payoutType } from "@/domain/utils/payoutUtils";
import { Financial, Payout } from "@/domain/entities";
import { FinancialMapper } from "@/domain/mappers";
import { FormatterService } from "@/domain/services";
import moment from "moment";
import { FinancialResponse, PayoutResponse } from "../dtos/responses";

export class FinancialMapperImpl implements FinancialMapper<
  FinancialResponse,
  PayoutResponse
> {
  constructor(private readonly currencyFormatter: FormatterService) {}

  toDomain(data: FinancialResponse): Financial {
    return {
      payouts: data.payouts.map((payout) => this.toPayoutDomain(payout)),
    };
  }

  toPayoutDomain(data: PayoutResponse): Payout {
    const statusObj = payoutStatus(data?.status);
    const date = data.arrival_date
      ? `${moment(data.arrival_date).format("DD/MM/YYYY")}`
      : "Aguardando";

    const item: Payout = {
      id: data.id,
      date,
      status: {
        value: data.status,
        label: statusObj["payoutDetailScreen"]?.status,
        color: statusObj["payoutDetailScreen"]?.color,
      },
      value: this.currencyFormatter.format(data.amount),
      arrival_date: date,
      bank_account: undefined,
      transactions: [],
    };

    if (data.bank_account) {
      item.bank_account = {
        routing_number: data.bank_account.routing_number,
        bank_name: data.bank_account.bank_name,
        type_label:
          data.bank_account?.account_holder_type == "individual" ? "PF" : "PJ",
        last_digits: `***${data?.bank_account?.last4}`,
      };
    }

    if (data.transactions) {
      item.transactions = data.transactions.map((elem, index, arr) => {
        let transaction: any = {
          payout_type: payoutType(elem.type, elem.reporting_category),
          net: this.currencyFormatter.format(elem.net),
          refer_to_another_payout:
            elem.type === "payout_failure" &&
            elem.reporting_category === "payout_reversal" &&
            elem.source_payout,
        };

        if (elem.appointment) {
          transaction = {
            ...transaction,
            user: {
              name: elem.appointment.user.name,
            },
            appointment: {
              id: elem.appointment_id,
              date: moment(elem.appointment.date).format("DD/MM/YY [-] HH:mm"),
            },
          };
        }

        if (elem.source_payout) {
          transaction.source_payout = {
            date: moment(elem.source_payout.arrival_date).format("DD/MM/YY"),
          };
        }

        return transaction;
      });
    }

    return item;
  }
}
